import _ from 'lodash'
import dropdown from 'scoreboard/components/dropdown'

const Operators = {
	text: function() {
		return [
			{id:'contains-any', label:'report.criteria.pretty.text.contains.any'},
			{id:'contains-all', label:'report.criteria.pretty.text.contains.all'},
			{id:'begins-with', label:'report.criteria.pretty.text.begins.with'},
			{id:'ends-with', label:'report.criteria.pretty.text.ends.with'},
			{id:'does-not-begin-with', label:'datasets.filters.pretty.doesNotBeginWith'},
			{id:'does-not-end-with', label:'datasets.filters.pretty.doesNotEndWith'}
		]
	},
	set: function() {
		return [
			{id:'contains-any', label:'report.criteria.pretty.text.contains.any'},
			{id:'contains-all', label:'report.criteria.pretty.text.contains.all'}
		]
	},
	numeric: function() {
		return [
			{id:'equals', label:'report.criteria.pretty.numberOperatorType.EQUALS'},
			{id:'less-than', label:'report.criteria.pretty.numberOperatorType.LESS_THAN'},
			{id:'greater-than', label:'report.criteria.pretty.numberOperatorType.GREATER_THAN'},
			{id:'between-number', label:'report.criteria.pretty.numberOperatorType.BETWEEN'}
		]
	},
	actualValue: function() {
		return [
			{id:'equals', label:'report.criteria.pretty.numberOperatorType.EQUALS'},
			{id:'is-null', label:'report.criteria.pretty.metricValueType.IS_NULL'},
			{id:'is-na', label:'report.criteria.pretty.metricValueType.IS_NA'},
			{id:'is-yes', label:'report.criteria.pretty.metricValueType.IS_YES'},
			{id:'is-no', label:'report.criteria.pretty.metricValueType.IS_NO'},
			{id:'less-than', label:'report.criteria.pretty.numberOperatorType.LESS_THAN'},
			{id:'greater-than', label:'report.criteria.pretty.numberOperatorType.GREATER_THAN'},
			{id:'between-number', label:'report.criteria.pretty.numberOperatorType.BETWEEN'}
		]
	},
	trend: function() {
		return [
			{id:'downward', label:'report.customReport.filter.trend.downward'},
			{id:'upward', label:'report.customReport.filter.trend.upward'}
		]
	},
	populate: function(select, type, currentValue) {
		let values = this[type]
		if (!values) {
			return
		}
		let v = values()
		let val = currentValue || _.head(v).id
		dropdown.idLabels(select, v, val)
	}
}

export default Operators

Operators.__filename__ = 'reports/common/filter/filter-operators.js'
